import { EditPage, EditPageTextField, EditPageCheckbox, EditPagePanel } from './../../../../../common/EditPage';
import Panel from '../../../../../common/layout/Panel'
import { getOne, create } from './../../../../../common/v4/BackendProvider';
import { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import SelectContainer from '../../../../../common/SelectContainer';

const SmsRateItemCreate = (props) => {

    const [data, setData] = useState({
        'ATRSMSMASTERCODEID': '',
        'ATRRATE': '0.00',
        'ATRCURID': '',
        'ATRSTATUS': true,
        'effective_from': new Date().toISOString().split('T')[0] + ' 00:00:00'
    });
    const [metadata, setMetadata] = useState({});
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { rate_id } = useParams();
    useEffect(() => {
        getOne(`/admin/products/sms/rates/${rate_id}/items/`, 'new')
            .then(response => {
                setMetadata(response.data.metadata);
                setLoading(false);
            }).catch(error => {
                setLoading(false);
            });
    }, []);

    const handleSave = () => {
        create(`/admin/products/sms/rates/${rate_id}/items/`, {data: data})
            .then(response => {
                toast.success('SMS Rate Item created successfully');
                navigate(`/products/sms/rates/${rate_id}`);
            }).catch(error => {
                toast.error('Error creating sms rate item: ' + error.message);
            });
    }

    const handleCancel = () => {
        navigate(`/products/sms/rates/${rate_id}`);
    }

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    }

    return (<> 
        <Panel title = "SMS Rate Items">
            <div>
                <ToastContainer />
                <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create SMS Rate Item">
                    <EditPagePanel>
                        <SelectContainer label="Destination" id="ATRSMSMASTERCODEID" onChange={ onChange } value={ data.ATRSMSMASTERCODEID } options={ metadata?.sms_master_code_id?.values } />
                        <EditPageTextField label="Rate" id="ATRRATE" onChange={ onChange } value={ data.ATRRATE } />
                        <SelectContainer label="Currency" id="ATRCURID" onChange={ onChange } value={ data.ATRCURID } options={ metadata?.currency_id?.values } />
                        <EditPageTextField label="Effective From" id="effective_from" onChange={ onChange } value={ data.effective_from } />
                        <EditPageCheckbox label="Enabled" id="ATRSTATUS" onChange={ onChange } value={ data.ATRSTATUS } />
                    </EditPagePanel>
                </EditPage>
            </div>
        </Panel>
        </>
    )
}

export default SmsRateItemCreate;